export default __webpack_public_path__ + "static/media/newyork.d8d258bc.jpg";